
import { IDataProviderRequest } from "@/interfaces/data-provider";
import { useCatalog, useMetadataCatalog } from "@/store";
import { defineComponent } from "@vue/composition-api";
import { zipObject } from "lodash";
import { mapState } from "pinia";
import config from "@/util/constants";

export default defineComponent({
  name: "AddDataDesc",
  data: () => ({
    timeTbl: new Array<any>(),
    projectTbl: new Array<any>(),
    ethicalLevelTbl: new Array<any>(),
    dpRequest: {} as IDataProviderRequest,
    fields: new Array<string>(),
    items: new Array<any>(),

    // timeTblN: "time",
    // dataDescCatTblN: "data_desc_cat",
    // projectTblN: "project",
    // ethicalLevelTblN: "ethical_level",
    // tblPath: "/data_mgmt/all/System/",

    timeTblN: config.metaCat.v_time,
    dataDescCatTblN: config.metaCat.v_data_desc_cat,
    projectTblN: config.metaCat.v_project,
    ethicalLevelTblN: config.metaCat.v_ethical_level,
    tblPath: "/meta_cat/",

    dataCatEntry: {
      data_cat_id: { val: null, type: Number, isRequired: true },
      high_level_desc: { val: null, type: String, isRequired: true },
      validity_time_amt: { val: null as any, type: Number, isRequired: false },
      detailed_desc: { val: null, type: String, isRequired: false },
      creation_method_desc: { val: null, type: String, isRequired: false },
      usage_rules_desc: { val: null, type: String, isRequired: false },
      validity_time_id: { val: null, type: Number, isRequired: false },
      project_id: { val: null, type: Number, isRequired: false },
      changes_gdpr_purpose: { val: null, type: Boolean, isRequired: false },
      ethical_level_id: { val: null, type: Number, isRequired: false },
      ethical_desc: { val: null, type: String, isRequired: false },
      created_date: { val: null, type: String, isRequired: false },
      update_log_id: { val: null, type: Number, isRequired: true },
    },
  }),
  computed: {
    ...mapState(useCatalog, ["tableMeta", "tableData"]),
    ...mapState(useMetadataCatalog, [
      "dataDescCatUri",
      "updateLogId",
      "selectedDataCatId",
    ]),
  },
  watch: {},
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.dataCatEntry.data_cat_id.val = this.selectedDataCatId;
      this.dataCatEntry.update_log_id.val = this.updateLogId;
      await this.catalogChange(this.timeTblN);
      await this.catalogChange(this.projectTblN);
      await this.catalogChange(this.ethicalLevelTblN);
    },
    async loadData(tableName: string, columns: Array<string>) {
      await useCatalog()
        .getTableData({
          catalogUri: this.tblPath + tableName,
          request: this.dpRequest,
        })
        .then(() => this.setTableData(tableName, columns));
    },
    setTableData(tableName: string, columns: Array<string>) {
      if (this.tableData?.rows.length) {
        switch (tableName) {
          case this.timeTblN:
            this.timeTbl = this.tableData?.rows.map((r: unknown[]) =>
              zipObject(columns, r)
            );
            break;
          case this.projectTblN:
            this.projectTbl = this.tableData?.rows.map((r: unknown[]) =>
              zipObject(columns, r)
            );
            break;
          case this.ethicalLevelTblN:
            this.ethicalLevelTbl = this.tableData?.rows.map((r: unknown[]) =>
              zipObject(columns, r)
            );
            break;
          default:
            this.showMessage(
              "danger",
              "Couldn't find the matching table name!! - " + tableName
            );
            break;
        }
      }
    },
    async catalogChange(tableName: string) {
      // Retrieve table meta
      await useCatalog()
        .getTableMeta({
          catalogUri: this.tblPath + tableName,
          request: {},
        })
        .then(() => {
          this.setTableColumns(tableName);
        });
    },
    setTableColumns(tableName: string) {
      if (this.tableMeta?.columns.length) {
        let columns = this.tableMeta.columns.map(
          (c: { columnName: string }) => c.columnName
        );
        this.loadData(tableName, columns);
      }
    },
    async updateDB(param: string) {
      if (
        this.dataCatEntry.validity_time_amt.val !== null &&
        this.dataCatEntry.validity_time_amt.val !== ""
      ) {
        this.dataCatEntry.validity_time_amt.val = Number(
          this.dataCatEntry.validity_time_amt.val
        );
      }

      const methodN = "updateDB";
      const requestFrom = "data_desc_cat";
      const nextPage = "field_cat";
      const catUri = this.tblPath + this.dataDescCatTblN;

      this.$emit(
        methodN,
        requestFrom,
        param,
        this.dataCatEntry,
        nextPage,
        catUri,
        this.dataDescCatUri
      );
    },
    showMessage(type: string, msg: string) {
      this.$root.$emit("showAlert", 4, type, msg);
    },
  },
});
